module.exports = __webpack_public_path__ + "img/valid.eb31e777.svg";